import { render, staticRenderFns } from "./CardTarjaEnqueteRedacaoSportvWithQRCode.vue?vue&type=template&id=70cfe837&scoped=true"
import script from "./CardTarjaEnqueteRedacaoSportvWithQRCode.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteRedacaoSportvWithQRCode.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteRedacaoSportvWithQRCode.vue?vue&type=style&index=0&id=70cfe837&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cfe837",
  null
  
)

export default component.exports